"use client";

import { ShoppingBag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useHydratedCartCount } from "@/hooks/useHydratedCartCount";
import { CartSheet } from "./CartSheet";

/** Sticky cart button - only render on /products page */
export function ProductsPageCart() {
  // Hydration-safe count (0 on first paint → no #418, real count after mount).
  const count = useHydratedCartCount();

  return (
    <div className="fixed bottom-[max(1rem,env(safe-area-inset-bottom))] right-[max(1rem,env(safe-area-inset-right))] z-40 flex flex-col items-end sm:bottom-[max(1.5rem,env(safe-area-inset-bottom))] sm:right-[max(1.5rem,env(safe-area-inset-right))]">
      <CartSheet
        trigger={
          <Button
            size="lg"
            className="relative h-16 w-16 min-h-14 min-w-14 rounded-full shadow-lg sm:min-h-0 sm:min-w-0"
            aria-label={`Cart${count > 0 ? ` (${count} items)` : ""}`}
          >
            <ShoppingBag className="size-8" />
            {count > 0 && (
              <Badge
                variant="secondary"
                className="absolute -right-0.5 -top-0.5 flex h-6 min-w-6 items-center justify-center rounded-full border-2 border-background bg-foreground px-1 text-xs font-semibold text-background"
              >
                {count > 99 ? "99+" : count}
              </Badge>
            )}
          </Button>
        }
      />
    </div>
  );
}
